import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTenantImages } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { SummaryLineType, type ISummaryLineItem } from "@overrides/types";
import { submitExchangeReq } from "../../store";
import {
  getOriginalItinerary,
  getPassengers,
} from "../../store/policySelectors";

export const useFlightExchangeManualRebook = () => {
  const { t } = useI18nContext();
  const dispatch = useDispatch();

  // TODO: Source these properly
  const travelers = useSelector(getPassengers);
  const contactInfo = {
    phone: travelers?.contact.contact.phoneNumber,
    email: travelers?.contact.contact.emailAddress,
  };

  const itinerary = useSelector(getOriginalItinerary);
  const [loadingTitle, setLoadingTitle] = useState("");

  const itineraryData = useMemo(() => {
    const bookedItinerary = itinerary?.bookedItinerary;
    const sellingPricing = bookedItinerary?.sellingPricing;
    return {
      sellingPricing,
    };
  }, [itinerary]);

  const totalPricing = itineraryData?.sellingPricing?.totalPricing;
  // TODO: Get pricing breakdown
  const priceBreakdown = {
    tripPriceLineItems: [
      {
        baseAmount: {
          label: "Base Amount",
          value: "$458.59",
        },
        taxesAndFees: {
          label: "Taxes",
          value: "$64.59",
        },
      },
    ],
    summaryLineItems: [
      {
        label: "Total",
        // TODO: ensure that this price formatting is correct
        value: totalPricing?.total.fiat.value.toString(),
        type: SummaryLineType.TOTAL,
      } as ISummaryLineItem,
    ],
  };
  // TODO: Get existing payment method details
  const paymentMethod = {
    identifier: "VISA ****5432",
    type: "Credit card",
  };

  //TODO: get real value
  const totalPayableDifference = "$523.18";

  const images = useTenantImages();

  const scheduleManualRebook = useCallback(async () => {
    setLoadingTitle(t("exchangeable.loading.fulfill"));
    dispatch(
      submitExchangeReq(
        totalPricing?.total.fiat || {
          currencyCode: "UNKNOWN",
          currencySymbol: "UNKNOWN",
          value: 0,
        }
      )
    );
  }, []);

  return {
    copy: {
      contactInfo: t("reviewContactInformation"),
      phoneNumber: t("phoneNumber"),
      email: t("email"),
      travelerInfo: t("travelerInformation"),
      priceBreakdown: t("priceBreakdown"),
      requestButton: t("exchangeable.core.rebook.requestButton"),
      paymentMethod: t("paymentMethod"),
      rebookTitle: t("exchangeable.core.rebook.title"),
      rebookSubtitle: t("exchangeable.core.rebook.subtitle"),
      totalPayableDifference: t(
        "exchangeable.core.rebook.totalPayableDifference"
      ),
      outbound: t("outbound"),
      return: t("return"),
      updateRequested: t("exchangeable.core.rebook.updateRequested"),
    },
    context: {
      contactInfo: contactInfo,
      travelers: travelers,
      priceBreakdown: priceBreakdown,
      totalPayableDifference: totalPayableDifference,
      paymentMethod: paymentMethod,
      loadingTitle: loadingTitle,
      images,
    },
    handlers: {
      scheduleManualRebook,
    },
  };
};
